import { Link, useLocation } from "react-router-dom";
import {
  Briefcase,
  CheckSquare,
  LayoutDashboard,
  MoreHorizontal,
  Users,
} from "lucide-react";
import { cn } from "@/cn";
import { isActivePath } from "@/lib/nav-items";
import { useMobileNav } from "@/components/mobile-nav-context";

const TABS = [
  { id: "home", href: "/", label: "Home", icon: LayoutDashboard },
  { id: "leads", href: "/user/leads", label: "Leads", icon: Users },
  { id: "deals", href: "/deals", label: "Deals", icon: Briefcase },
  { id: "tasks", href: "/tasks", label: "Tasks", icon: CheckSquare },
] as const;

export function MobileBottomNav() {
  const { pathname } = useLocation();
  const { drawerOpen, openDrawer, closeDrawer } = useMobileNav();

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-bg md:hidden"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <ul className="flex h-14 items-stretch">
        {TABS.map((tab) => {
          const active = isActivePath(tab.href, pathname);
          const Icon = tab.icon;
          return (
            <li key={tab.id} className="flex-1">
              <Link
                to={tab.href}
                onClick={() => closeDrawer()}
                className={cn(
                  "flex h-full flex-col items-center justify-center gap-0.5 text-[10px] font-medium",
                  active
                    ? "text-brand"
                    : "text-muted-foreground hover:text-foreground",
                )}
                aria-current={active ? "page" : undefined}
              >
                <Icon className="size-5" aria-hidden />
                <span>{tab.label}</span>
              </Link>
            </li>
          );
        })}
        <li className="flex-1">
          <button
            type="button"
            onClick={() => (drawerOpen ? closeDrawer() : openDrawer())}
            className={cn(
              "flex h-full w-full flex-col items-center justify-center gap-0.5 text-[10px] font-medium",
              drawerOpen
                ? "text-brand"
                : "text-muted-foreground hover:text-foreground",
            )}
            aria-label="More navigation"
            aria-expanded={drawerOpen}
          >
            <MoreHorizontal className="size-5" aria-hidden />
            <span>More</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
